export default {
  token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2OTcwMjk3ODcsImV4cCI6MTc2MDEwMTc4NywiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSJ9.isWLca_frlsTJlQnhE4GmgCD9uzSLd4Afn4Yxch8bqY',
  userIdentifier: 'user',
}
